import { AvaibookService } from "../_services/avaibook.service";
import { AvaibookStore } from "../_stores/AvaibookStore";
import { genericActions } from "./generic.actions"

export const avaibookActions = {
    listAccommodations,
}

function listAccommodations(integrationUID: string) {
    return async (dispatch) => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const listings = await AvaibookService.listAccommodations(integrationUID);
            dispatch(AvaibookStore.actionListItemsSuccess(listings));
        }
    }
}